import { diContainer, serviceNames } from '../diContainer/diContainer';
import Address from '../domain/entities/Address';
import BillingRepository from '../repositories/BillingRepository';
import TransactionLoadHandler, { ITransactionLoad } from './TransactionLoadHandler';

class SaveNewBillingAddressUseCase extends TransactionLoadHandler {
  private billingRepository: BillingRepository;

  constructor(options?: ITransactionLoad) {
    super({ ...options?.transactionLoadOptions, isControlled: true });
    this.billingRepository = diContainer.get(serviceNames.billingRepository);
  }

  protected async run(): Promise<void> {
    const {
      transactionRepository,
      billingRepository,
    } = this;
    const transaction = await transactionRepository.getTransaction();
    const {
      billingAddress,
    } = transaction;

    if (billingAddress.isNewAddress) {
      const billingAddressFromStore = billingRepository.formStore.toAddress();
      const newBillingAddress: Address = await billingRepository.saveNewAddress(
        billingAddressFromStore,
      );
      transaction.setBillingAddress(billingRepository.getAddressById(newBillingAddress.id));
      await this.handleTransactionUpdate();
    }
  }
}

export default SaveNewBillingAddressUseCase;
